module.exports = __webpack_public_path__ + "img/cam-circle.1d810634.svg";